/**
 * Sticky functionality
 *
 * @description This file includes the required sticky functionality used in several pages
 *
 * @return void
 * @access public
 *
 */

/**
 * Import 3rd party libraries
 */
import stickybits from 'stickybits';

/**
 * Import global variables
 */
import {body, header, headerLogo, wpAdminBarSpace, viewportWidth} from './helpers';

export const sticky = () => {
	let lastStickyId = ''

	const topMenus              = document.getElementsByClassName( 'c-sticky-bar' );
	const origTopCoordinateMenu = header.offsetTop;

	/**
	 * Make `.c-sticky-bar` sticky on scroll
	 *
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 *
	 */
	stickybits( '.js-sticky-bar', {
		stickyBitStickyOffset: 88,
		useStickyClasses: true
	} );


	/*
	* Make `.js-sticky-side-cta` sticky on scroll
	*
	*
	* @since  1.0.0
	* @access public
	* @return void
	*
	*/
	stickybits('.js-sticky-side-cta', {
		stickyBitStickyOffset: 140,
	});


	/*
	* Make `.js-sticky-social-sharing` sticky on scroll
	*
	*
	* @since  1.0.0
	* @access public
	* @return void
	*
	*/
	stickybits('.js-sticky-social-sharing', {
		stickyBitStickyOffset: 140,
	});


	/**
	 * Highlight certain sticky menu item on scroll
	 * once the corresponding section is reached on scroll
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 *
	 */
	if ( topMenus.length ) {
		const topMenu                 = topMenus[0]
		const topMenuHeight           = topMenu.offsetHeight + 100
		const stickyMenuItemsNodeList = topMenu.querySelectorAll( '.js-page-nav-link' )
		const stickyMenuItems         = Array.prototype.slice.call( stickyMenuItemsNodeList )
		const scrollItems             = stickyMenuItems.map( function ( el, index ) {

			let itemHref = el.getAttribute( 'href' );
			let itemID   = itemHref.replace( '#', '' )
			let item     = document.getElementById( itemID )
			if ( item ) {
				return item
			}

		} );

		// Bind to scroll
		window.addEventListener( 'scroll', function () {
			const stickyWrappers = document.getElementsByClassName( 'c-sticky-bar' )
			if ( stickyWrappers.length ) {
				let stickyWrapper = stickyWrappers[0]
				const fromTop     = stickyWrapper.getBoundingClientRect().top + topMenuHeight

				// Get id of current scroll item
				let currentItem
				scrollItems.forEach( function ( el ) {
					if ( -1 !== Math.sign( el.getBoundingClientRect().top ) ) {
						if ( el.getBoundingClientRect().top < fromTop ) {
							currentItem = el
						}
					}
				} )

				if ( currentItem ) {

					if ( lastStickyId !== currentItem.id ) {
						lastStickyId = currentItem.id
						stickyMenuItems.forEach( function ( el ) {
							el.parentNode.classList.remove( 'c-page-nav__item--active' )
							const elHrefId = el.getAttribute( 'href' ).replace( '#', '' )
							if ( currentItem.id === elHrefId ) {
								el.parentNode.classList.add( 'c-page-nav__item--active' )

							}
						} )

					}

				}

			}

		} )

	}

	/**
	 * Implement sticky header functionality on scroll
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	window.onscroll = function () {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

		if ( scrollTop >= origTopCoordinateMenu + (wpAdminBarSpace + 1) ) {
			header.classList.add( 'c-header--sticky' );
			headerLogo.classList.add( 'c-logo--sticky' );
		} else {
			header.classList.remove( 'c-header--sticky' );
			headerLogo.classList.remove( 'c-logo--sticky' );
		}
	};
}
